<script lang="ts">
	import { t, api } from "@hitit/hub/src/stores";
	import { Card, Pagenation } from "@hitit/new_ui";
	import ComponentLoading from "../common/ComponentLoading.svelte";
	import { RewardStatus, type RewardMinDTO } from "@hitit/api";
	import moment from "moment";
	export let storeId = "";
	export let userId = "";

	let presentPage = 0;
	let totalPage = presentPage;
	let list: RewardMinDTO[] = [];
	let loading = false;

	const addMinusSignStatus = [
		RewardStatus.USED,
		RewardStatus.EXPIRED,
		RewardStatus.REDEEMED,
	];
	const cancelColorStatus = [
		RewardStatus.USED,
		RewardStatus.EXPIRED,
		RewardStatus.REDEEMED,
	];

	function addSignByStatus(status: RewardStatus, message: string | number) {
		if (typeof message == "number") {
			message = String(message);
			return Number(message) < 0 ? message : "+" + message;
		}
		const sign = addMinusSignStatus.indexOf(status) >= 0 ? "-" : "+";
		return `${sign} ${message}`;
	}

	function makePointStatusColumnClass(status: RewardStatus) {
		return cancelColorStatus.indexOf(status) >= 0;
	}
	function processingDate(time: string) {
		if (!time) return "";
		return !time
			? ""
			: moment(new Date(time + "Z").toISOString()).format("yyyy.MM.DD HH:mm");
	}

	// React By presentPage
	$: (async (_presentPage) => {
		try {
			loading = true;
			const { data } = await $api.getRewardsFromStoreByUser(
				storeId,
				_presentPage,
				userId
			);
			if (_presentPage === presentPage) {
				list = [...data.rewardMinDTOs];
				totalPage = data.totalPages;
			}
		} catch (e) {
		} finally {
			loading = false;
		}
	})(presentPage);

</script>

<Card noPadding>
	<div class="container">
		<div class="header">
			<div class="col type">{$t('global.point.pointColumn.type')}</div>
			<div class="col order">{$t('global.point.pointColumn.orders')}</div>
			<div class="col use">{$t('global.point.pointColumn.amount')}</div>
			<div class="col create">{$t('global.point.pointColumn.date')}</div>
		</div>
		<div class="body">
			{#if loading}
				<ComponentLoading coverMode />
			{/if}
			{#each list as reward}
				<div class="row">
					<div
						class="col type"
						class:cancel={makePointStatusColumnClass(reward.rewardStatus)}>
						{addSignByStatus(reward.rewardStatus, String($t(`global.point.rewardStatus.${reward.rewardStatus}`)))}
					</div>
					<div class="col order">
						{#each reward.summary as item}{item}{/each}
					</div>
					<div class="col use">
						{addSignByStatus(reward.rewardStatus, reward.reward)}P
					</div>
					<div class="col create">{processingDate(reward.createdDate)}</div>
				</div>
			{/each}
		</div>
		<div class="pagenation">
			<Pagenation
				totalPage={totalPage}
				presentPage={presentPage}
				buttonCallback={(page) => (presentPage = page)} />
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px 15px 20px 15px;

		.header {
			display: none;
		}

		.body {
			margin-bottom: 20px;
			.row {
				display: flex;
				flex-wrap: wrap;
				gap: 10px 0px;
				padding: 10px 0px;
				color: #46474b;
				box-sizing: border-box;
				&:not(:last-child) {
					border-bottom: 1px solid #e6e7ec;
				}
				.type,
				.use {
					font-weight: 500;
				}

				.type {
					order: 1;
					flex-basis: 75px;
					color: #6591fa;
					&.cancel {
						color: #e54848;
					}
				}

				.use {
					flex-grow: 1;
					order: 2;
					text-align: right;
				}

				.order {
					flex-basis: 100%;
					order: 3;
				}
				.create {
					flex-basis: 100%;
					order: 4;
				}
			}
		}

		.pagenation {
			width: 100%;
		}
	}

	@include DesktopSize {
		.container {
			padding: 30px;
			gap: 10px;

			.header {
				display: flex;
				color: #6d6f76;
				font-size: 1.25rem;
			}

			.col {
				text-align: center;
			}

			.type {
				flex-basis: 75px;
				min-width: 75px;
			}

			.create {
				flex-basis: 150px;
				min-width: 150px;
				width: 150px;
				text-align: center;
			}

			.order {
				flex-basis: 100%;
				flex-grow: 46;
				max-width: calc((100% - 75px - 150px) * 0.6);
				text-align: center;
			}

			.use {
				flex-basis: 100%;
				flex-grow: 4;
				max-width: calc((100% - 75px - 150px) * 0.4);
				text-align: center;
			}

			.body {
				margin-bottom: 10px;
				.row {
					display: flex;
					padding: 20px 0px;
					font-size: 1.25rem;
					.type {
						font-size: 1.5rem;
					}
					.use {
						order: 3;
					}
					.order {
						order: 2;
					}
					.use {
						text-align: center;
						flex-grow: 0;
						font-weight: 200;
					}
					.create {
						flex-basis: 150px;
					}
				}
			}
		}
	}

</style>
